import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Prop types for TypeScript callers. @types/react 19 no longer reads `propTypes`,
// and React 19 ignores them at runtime.
/**
 * @param {object} props
 * @param {string} [props.email]
 * @param {string | number} [props.id]
 */
const UserTitle = ({ email, id }) => {
  return (
    <Box
      sx={{
        m: "1.25rem 0",
      }}
    >
      <Typography variant="body1">
        #<Typography variant="button">{id}</Typography>, <Typography variant="button">{email || "-"}</Typography>
      </Typography>
    </Box>
  );
};

export default UserTitle;
